import { render, staticRenderFns } from "./ReceiptViewSingle.vue?vue&type=template&id=af22e4a4&scoped=true&"
import script from "./ReceiptViewSingle.vue?vue&type=script&lang=js&"
export * from "./ReceiptViewSingle.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptViewSingle.vue?vue&type=style&index=0&id=af22e4a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af22e4a4",
  null
  
)

export default component.exports